import React from 'react';

import { LoadType } from '@paragon/contract-library';
import { Direction2D, Point2D } from '@paragon/geometry-library';

import { getLoadMaterial } from '../../library/getLoadMaterial';
import { VectorVisual, VectorVisualType } from '../util/VectorVisual';

const arrowBufferAmount = 4;
const zDepth = 6;

interface Props {
  readonly loadLocation: Point2D;
  readonly loadDirection: Direction2D;
  readonly arrowMagnitude: number;
  readonly loadType: LoadType;
  readonly label: React.JSX.Element | null;
}

export function PointLoadVisual({ loadLocation, loadDirection, arrowMagnitude, loadType, label }: Props) {
  const arrowEnd = loadLocation.translate(loadDirection.toVector(-arrowBufferAmount));
  const arrowStart = arrowEnd.translate(loadDirection.toVector(-arrowMagnitude));

  return (
    <object3D>
      <VectorVisual
        segment={{ start: arrowStart.to3D(zDepth), end: arrowEnd.to3D(zDepth) }}
        thickness={0.5}
        vectorVisualType={VectorVisualType.Wine}
        withBox
        boxMaterial={getLoadMaterial(loadType)}
      />

      {label}
    </object3D>
  );
}

export function getInitialPointLoadLabelPosition(
  loadLocation: Point2D,
  loadDirection: Direction2D,
  arrowMagnitude: number,
) {
  const arrowStartOffset = arrowBufferAmount + arrowMagnitude;
  const additionalLabelOffset = arrowBufferAmount / 2;
  const labelOffset = arrowStartOffset + additionalLabelOffset;

  return loadLocation.translate(loadDirection.toVector(-labelOffset));
}
